import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NotificationService } from '@libs/services/notification.service';
import { FeedbackWithGoHomeComponent } from '../../components/feedback-with-go-home/feedback-with-go-home.component';

@Component({
  selector: 'app-temporarily-unavailable',
  imports: [CommonModule, FeedbackWithGoHomeComponent],
  templateUrl: './temporarily-unavailable.component.html',
  styleUrl: './temporarily-unavailable.component.scss',
})
export class TemporarilyUnavailableComponent {
  notificationService = inject(NotificationService);
  constructor() {
    this.notificationService.isProgressIndicator.set(false);
  }
}
